import { render, staticRenderFns } from "./UserAddUpdate.html?vue&type=template&id=477b43ea&"
import script from "./UserAddUpdate.vue?vue&type=script&lang=js&"
export * from "./UserAddUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports